import { Component } from "react";

export class ErrorBoundary extends Component {
  constructor(props) {
    super(props);
    this.state = { hasError: false };
  }

  static getDerivedStateFromError(error) {
    // Update state so the next render will show the fallback UI.
    return { hasError: true };
  }

  componentDidCatch(error, errorInfo) {
    // You can also log the error to an error reporting service
    console.log(error, errorInfo);
  }

  render() {
    if (this.state.hasError) {
      return (
        <div className="d-flex justify-content-center align-items-center">
          <div className="mx-auto text-center mt-5 border p-3 rounded-3">
            <h3>Something went wrong!</h3>
            <p className="py-2">Please try again later.</p>
            <a href="/" className="btn btn-danger">
              Back toHome
            </a>
          </div>
        </div>
      );
    }

    return this.props.children;
  }
}
